import React from 'react';
import { Box, Layout, Text, Spacer, Button } from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import NotFound from 'assets/images/404.svg';

export const Page404 = () => (
  <>
    <Layout>
      <Box
        width="99vw"
        height="99vh"
        display="grid"
        style={{ placeItems: 'center' }}
      >
        <Box align="center" margin="auto">
          <img src={NotFound} alt="404 not found" />
          <Box margin="20px auto 0" align="center" maxWidth="300px">
            <Text bold block size="18px">
              Page not Found
            </Text>
            <Spacer space="15px" />
            <Text block>
              The Page you are looking for could not be found, you can visit the
              dashboard to continue.
            </Text>
            <Spacer space="30px" />
            <Button
              onClick={() => window.history.back()}
              width={180}
              bold
              height={45}
            >
              Go Back
            </Button>
          </Box>
        </Box>
      </Box>
    </Layout>
  </>
);

Page404.propTypes = {
  title: PropTypes.string,
};
